import React from 'react'

export interface SelectieDescriptor {
  code: number
  omschrijving: string
}

export const placeholder: SelectieDescriptor[] = [
  { code: 0, omschrijving: 'Nog geen data...' },
]

export default function SelectieButton({
  type,
  options,
  selected,
  onChange,
  readonly,
  labelClassName = null,
  className = null,
}) {
  options = options === undefined ? placeholder : options
  return (
    <div>
      <label key={type} className={labelClassName}>
        <select
          className={`styled-select ${className}`}
          disabled={readonly}
          defaultValue={selected}
          onChange={onChange}
        >
          {options.map((opt: SelectieDescriptor) => (
            <option key={opt.code} value={opt.code}>
              {opt.omschrijving}
            </option>
          ))}
          ;
        </select>
      </label>
    </div>
  )
}
